import type { InferOutput } from 'valibot'
import type { FacetCounts } from '~/utils/solr/facet'
import { object } from 'valibot'
import { facetCountsSchema } from '~/utils/solr/facet'
import { headersSchema } from '~/utils/solr/headers'

const facetResponseSchema = object({
  responseHeader: headersSchema,
  facet_counts: facetCountsSchema,
})

export type FacetResponseSchema = InferOutput<typeof facetResponseSchema>

export function useSearchFacetPreload() {
  const queryOptions = useSolrQueryOptions({
    endpoint: 'facets',
    schema: facetResponseSchema,
    safe: true,
  })

  const { data } = useQuery(queryOptions)

  const facets = computed<FacetCounts | undefined>(() => data.value?.facet_counts)

  return { facets }
}
